import { Writable } from 'stream';
export class WriteStream extends Writable {
    writeCb;
    closeCb;
    constructor(writeCb, closeCb) {
        super();
        this.writeCb = writeCb;
        this.closeCb = closeCb;
    }
    _write(chunk, encoding, callback) {
        const buffer = Buffer.isBuffer(chunk) ? chunk : Buffer.from(chunk, encoding);
        this.writeCb(buffer).then(() => callback(), callback);
    }
    _destroy(err, callback) {
        this.closeCb()
            .then(() => callback(err), callback)
            .catch((closeErr) => callback(closeErr));
    }
}
